import type { HeaderTableColumn } from '@/shared/models';

export const STUDENT_TABLE_COLUMNS: HeaderTableColumn[] = [
  { key: 'enrollment_number', label: 'matrícula', sortable: true },
  { key: 'full_run', label: 'rut', sortable: true, fixed: true },
  { key: 'first_name', label: 'nombres', sortable: true, fixed: true },
  { key: 'last_name1', label: 'paterno', sortable: true, fixed: true },
  { key: 'last_name2', label: 'materno', sortable: true, fixed: true },
  { key: 'year', label: 'año ingreso', sortable: true },
  { key: 'gender', label: 'genero', sortable: true },
  { key: 'campus', label: 'sede', sortable: true },
  { key: 'schedule', label: 'jornada', sortable: true },
  { key: 'career_short_name', label: 'carrera', sortable: true },
  { key: 'risk_level', label: 'nivel riesgo', sortable: true, fixed: true },
  { key: 'acciones', label: 'acciones', fixed: true },
];

export const INITIAL_VISIBLE_COLUMNS = [
  'full_run',
  'first_name',
  'last_name1',
  'last_name2',
  'year',
  'risk_level',
  'acciones',
];
